

const GLOBAL_CONFIG = {
    rendererFormId: "vue-form-render-pro-max", // ID of <form> for Renderer
};

export {
    GLOBAL_CONFIG
}